export const getMoonPhase = (date = new Date()) => {
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();

  let c;
  let e;
  if (month < 3) {
    c = year - 1;
    e = month + 12;
  } else {
    c = year;
    e = month;
  }

  let jd = Math.floor(365.25 * c) + Math.floor(30.6001 * (e + 1)) + day - 694039.09;
  jd /= 29.5305882;
  jd -= Math.floor(jd);
  let phaseIndex = Math.round(jd * 8);
  if (phaseIndex >= 8) phaseIndex = 0;

  const phases = [
    { name: "New Moon", icon: "🌑", illumination: 0 },
    { name: "Waxing Crescent", icon: "🌒", illumination: 25 },
    { name: "First Quarter", icon: "🌓", illumination: 50 },
    { name: "Waxing Gibbous", icon: "🌔", illumination: 75 },
    { name: "Full Moon", icon: "🌕", illumination: 100 },
    { name: "Waning Gibbous", icon: "🌖", illumination: 75 },
    { name: "Last Quarter", icon: "🌗", illumination: 50 },
    { name: "Waning Crescent", icon: "🌘", illumination: 25 },
  ];

  return phases[phaseIndex];
};

export const getMoonTimes = (sunrise, sunset) => {
  const phase = getMoonPhase();
  const sunriseDate = new Date(sunrise * 1000);
  const sunsetDate = new Date(sunset * 1000);
  const phaseOffset = (phase.illumination / 100) * 12 * 60 * 60 * 1000;

  const moonrise = new Date(sunsetDate.getTime() - phaseOffset);
  const moonset = new Date(sunriseDate.getTime() + phaseOffset);

  return {
    moonrise: moonrise.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }),
    moonset: moonset.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit" }),
    phase,
  };
};